module.exports = __webpack_public_path__ + "img/rotationImgTwo.72659120.png";